import { createAction, props } from '@ngrx/store';

export const setMenuList = createAction('Menu List', props<{ menuList: any[] }>());
